import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { palette } from "./palettes";
import { useTheme } from "@/components/theme-provider";

export interface VroomBarChartProps<T extends object> {
  data: T[];
  xKey: keyof T & string;
  series: { key: keyof T & string; label: string }[];
  height?: number;
}

export function VroomBarChart<T extends object>({
  data,
  xKey,
  series,
  height = 240,
}: VroomBarChartProps<T>) {
  const { resolvedTheme } = useTheme();
  const colors = palette.cat();
  const axis = palette.axis();
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} key={resolvedTheme}>
        <CartesianGrid stroke={axis.grid} strokeDasharray="2 3" vertical={false} />
        <XAxis
          dataKey={xKey as never}
          stroke={axis.stroke}
          tick={{ fill: axis.text, fontSize: 11 }}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke={axis.stroke}
          tick={{ fill: axis.text, fontSize: 10.5 }}
          tickLine={false}
          axisLine={false}
        />
        <Tooltip
          cursor={{ fill: "var(--p-50)" }}
          contentStyle={{
            background: "var(--surface)",
            border: "1px solid var(--line)",
            borderRadius: 5,
            fontSize: 12,
          }}
        />
        {series.map((s, i) => (
          <Bar
            key={s.key}
            dataKey={s.key as never}
            fill={colors[i % colors.length]}
            name={s.label}
            radius={[2, 2, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
